import { defineComponent as l, createBlock as d, openBlock as i, unref as t, withCtx as a, createVNode as r, renderSlot as o } from "vue";
import { TabGroup as m, TabList as u } from "@headlessui/vue";
import { ScalarCardHeader as p } from "@scalar/components";
const C = /* @__PURE__ */ l({
  __name: "ExampleResponseTabList",
  emits: ["change"],
  setup(f, { emit: s }) {
    const c = s, n = (e) => {
      c("change", e);
    };
    return (e, _) => (i(), d(t(p), { class: "scalar-card-header scalar-card-header-tabs" }, {
      actions: a(() => [
        o(e.$slots, "actions", {}, void 0, !0)
      ]),
      default: a(() => [
        r(t(m), { onChange: n }, {
          default: a(() => [
            r(t(u), { class: "tab-list custom-scroll" }, {
              default: a(() => [
                o(e.$slots, "default", {}, void 0, !0)
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
});
export {
  C as default
};
